export const isMedicineLikeItemType = (itemType) =>
	itemType === "medicine" || itemType === "unani";

export const getStockApiTypeFilters = (itemType) => ({
	isOTC: itemType === "otc",
	isUnani: itemType === "unani",
});

export const getStockSearchPlaceholder = (itemType, t) =>
	isMedicineLikeItemType(itemType)
		? t("Search by brand, salt, manufacturer, etc.")
		: t("Search by product name, manufacturer");

export const getStockEmptyMessage = (itemType, t) => {
	if (itemType === "otc") return t("No OTC products found.");
	if (itemType === "unani") return t("No Unani medicines found.");
	return t("No medicines found.");
};

export const getStockItemTypeLabel = (item, t) => {
	if (item?.isOTC) return t("OTC Product");
	if (item?.isUnani) return t("U Medicine");
	return t("Medicine");
};
